<template>
  <div>
    <PageLoader v-bind:storage="appLoading" v-bind:contain="true" />
    <ServerError v-if="ServerError" />
    <v-layout wrap justify-center>
      <v-flex xs12 px-0 px-sm-4 pt-4>
        <v-layout wrap justify-center>
          <v-flex xs10 sm12 xl12 text-left text-uppercase>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 16px;
                color: #000000;
                letter-spacing: 1px;
              "
            >
              Saved Address
            </span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-start>
          <v-flex
            xs12
            sm4
            md4
            lg4
            xl4
            pa-2
            v-for="(item, i) in address"
            :key="i"
          >
            <Address
              v-bind:storage="item"
              v-bind:defaultAddress="defaultAddress"
              @stepper="winStepper"
              :key="defaultAddress"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import Address from "./savedAddressItem";
import axios from "axios";
export default {
  components: {
    Address,
  },
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      timeout: 5000,
      ServerError: false,
      msg: null,
      address: [],
      defaultAddress: {},
    };
  },
  mounted() {
    this.getProfile();
  },
  methods: {
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.address = response.data.data.deliveryaddress;
            for (var i = 0; i < this.address.length; i++) {
              if (
                response.data.data.deliveryaddressindex == this.address[i]._id
              ) {
                this.defaultAddress = this.address[i];
              }
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    winStepper(item) {
      if (item.ref == "DefaultAddressItem") {
        this.setDefaultAddress(item.address);
      }
    },
    setDefaultAddress(item) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/edit",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          deliveryaddressindex: item._id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            // this.msg = response.data.msg;
            this.msg = "Shipping Address Changed";
            this.showSnackBar = true;
            this.getProfile();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>